import { render, staticRenderFns } from "./GroupingHeader.vue?vue&type=template&id=bcfb9cea&scoped=true"
import script from "./GroupingHeader.vue?vue&type=script&lang=js"
export * from "./GroupingHeader.vue?vue&type=script&lang=js"
import style0 from "./GroupingHeader.vue?vue&type=style&index=0&id=bcfb9cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfb9cea",
  null
  
)

export default component.exports